export const CUSTOMER_RESPONSE_TYPE_UN = '未回复';
export const CUSTOMER_RESPONSE_TYPE_AGREE = '同意';
export const CUSTOMER_RESPONSE_TYPE_DISAGREE_AND_DECREASE = '要求减量';
export const CUSTOMER_RESPONSE_TYPE_DISAGREE = '不同意';

export const SEED_FARM_RESPONSE_UN = '未回复';
export const SEED_FARM_RESPONSE_AGREE = '同意';
export const SEED_FARM_RESPONSE_DISAGREE = '不同意';

export const RESULT_TYPE_UN = '待定';
export const RESULT_TYPE_NOT_BREAK = '不违约';
export const RESULT_TYPE_CUSTOMER_BREAK = '客户违约';
export const RESULT_TYPE_SEED_FARM_BREAK = '苗场违约';

export const DELIVERY_STATUS_YES = '已发货';
export const DELIVERY_STATUS_NO = '未发货';

export const COMPENSATION_STATUS_YES = '已退款';
export const COMPENSATION_STATUS_NO = '未退款';
export const COMPENSATION_STATUS_UN = '无需退款';

export const CUSTOMER_DEDUCTION_STATUS_TYPE_UN = '无需扣除';
export const CUSTOMER_DEDUCTION_STATUS_TYPE_YES = '已扣除';
export const CUSTOMER_DEDUCTION_STATUS_TYPE_NO = '未扣除';
